export const SELECT_STATE = 'SELECT_STATE';
export const SELECT_COUNTY = 'SELECT_COUNTY';
export const SELECT_FIELD = 'SELECT_FIELD';
export const SELECT_SEX = 'SELECT_SEX';
export const SELECT_AGE = 'SELECT_AGE';
export const SELECT_RACE = 'SELECT_RACE';
export const RESET_DEMO = 'RESET_DEMO';

export const GET_COUNTY_PROVIDERS = 'GET_COUNTY_PROVIDERS';
export const COUNTY_PROVIDERS_RECEIVED = 'COUNTY_PROVIDERS_RECEIVED';
export const GET_COUNTY_DATA = 'GET_COUNTY_DATA';
export const COUNTY_DATA_RECEIVED = 'COUNTY_DATA_RECEIVED';
export const GET_STATE_DATA = 'GET_STATE_DATA';
export const STATE_DATA_RECEIVED = 'STATE_DATA_RECEIVED';
export const GET_DEMOGRAPHICS_DATA = 'GET_DEMOGRAPHICS_DATA';
export const DEMOGRAPHICS_DATA_RECEIVED = 'DEMOGRAPHICS_DATA_RECEIVED';

export const UPDATE_OVERDOSE_LOCATIONS = 'UPDATE_OVERDOSE_LOCATIONS';


// WEBPACK FOOTER //
// ./src/actions/action-types.js